import gql from 'graphql-tag';
export const KinderConnectCaptureRequired = gql `
    query KinderConnectCaptureRequired($childIds: [ChildId!]!) {
        attendance {
            childCheckins {
                kinderConnectCaptureRequired(childIds: $childIds)
            }
        }
    }
`;
